var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 2.40001C2.3999 2.18783 2.48419 1.98435 2.63422 1.83432C2.78425 1.68429 2.98773 1.60001 3.1999 1.60001H12.7999C13.0121 1.60001 13.2156 1.68429 13.3656 1.83432C13.5156 1.98435 13.5999 2.18783 13.5999 2.40001V4.80001C13.5999 5.01216 13.5155 5.21561 13.3655 5.36561L9.5999 9.13121V12C9.59986 12.2122 9.51554 12.4156 9.3655 12.5656L7.7655 14.1656C7.65362 14.2775 7.51109 14.3536 7.35593 14.3845C7.20077 14.4153 7.03994 14.3995 6.89378 14.3389C6.74762 14.2784 6.62269 14.1759 6.53478 14.0444C6.44687 13.9128 6.39994 13.7582 6.3999 13.6V9.13121L2.6343 5.36561C2.48426 5.21561 2.39995 5.01216 2.3999 4.80001V2.40001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.cfbdf456db866e1f7591433921785ae2.svg";
export { ForwardRef as ReactComponent };